module.exports = __webpack_public_path__ + "img/kr-product-content4-img-2.0116e9a.png";